import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class NotificationsSidebarService { 
    openNotificationSideBar$: Observable<boolean>;
    unseenNotificationCount$: Observable<number>;
    private openNotificationSideBarEvent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    private updateUnseenNotificationCountEvent: BehaviorSubject<number> = new BehaviorSubject<number>(null);

    constructor() {
        this.openNotificationSideBar$ = this.openNotificationSideBarEvent.asObservable();
        this.unseenNotificationCount$ = this.updateUnseenNotificationCountEvent.asObservable();
    }

    openSideNavBar(): void {
        this.openNotificationSideBarEvent.next(true);
    }

    updateUnseenNotificationCount(count: number): void {
        this.updateUnseenNotificationCountEvent.next(count);
    }
}